(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-gc"]) return;
  try {
    
  if (!window.gcArticleCommerceTrackingReady) {
    window.gcArticleCommerceTrackingReady = true;

    const positionOf = (el) => {
      if (el.dataset && el.dataset.ctaPosition) return el.dataset.ctaPosition;
      if (el.closest('[data-gc-side]')) return 'sidebar';
      if (el.closest('[data-gc-decide]')) return 'decision_block';
      if (el.closest('[data-gc-bar]')) return 'sticky_bar';
      if (el.closest('[data-gc-rail]')) return 'end_rail';
      return 'inline';
    };
    /* Each event goes to: dataLayer (for a future GTM/GA4), Shopify customer events (custom pixels can subscribe),
       and Microsoft Clarity (custom event + session tags, countable in the Clarity dashboard today). */
    const push = (payload) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('gc:' + payload.event.replace(/_/g, '-'), { detail: payload }));
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          const data = Object.assign({}, payload); delete data.event;
          Shopify.analytics.publish(payload.event, data);
        }
      } catch (e) {}
      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', payload.event);
          if (payload.cta_position) window.clarity('set', 'gc_cta_position', payload.cta_position);
          if (payload.destination_type) window.clarity('set', 'gc_destination_type', payload.destination_type);
          if (payload.destination_url) window.clarity('set', 'gc_destination', payload.destination_url.split('?')[0]);
        }
      } catch (e) {}
    };
    const rootOf = (el) => el.closest('[data-gc-article-root]') || document.querySelector('[data-gc-article-root]');

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const root = rootOf(link);
      if (!root) return;
      const base = { article_url: root.dataset.articleUrl, article_language: root.dataset.articleLanguage, cta_position: positionOf(link) };

      if (link.hasAttribute('data-gc-finder')) {
        push(Object.assign({ event: 'article_finder_click', intent: link.dataset.gcFinder }, base));
        return;
      }
      let destination;
      try { destination = new URL(link.href, window.location.origin); } catch (error) { return; }
      const isProduct = destination.pathname.startsWith('/products/');
      const isCollection = destination.pathname.startsWith('/collections/');
      if (!isProduct && !isCollection) return;
      push(Object.assign({ event: 'article_commerce_click', destination_url: `${destination.pathname}${destination.search}`, destination_type: isProduct ? 'product' : 'collection' }, base));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[data-gc-atc]');
      if (!form) return;
      const root = rootOf(form);
      if (!root) return;
      push({ event: 'article_add_to_cart', article_url: root.dataset.articleUrl, article_language: root.dataset.articleLanguage, product_handle: form.dataset.productHandle, cta_position: positionOf(form) });
    }, true);

    /* reading progress + index scroll-spy + sticky sidebar that always fits */
    const root = document.querySelector('[data-gc-article-root]');
    const body = root && root.querySelector('.gcj__body');
    const fill = root && root.querySelector('[data-gc-progress]');
    const pct = root && root.querySelector('[data-gc-toc-pct]');
    const side = root && root.querySelector('[data-gc-side]');
    const tocLinks = side ? [...side.querySelectorAll('[data-gc-side-toc] a')] : [];
    const heads = tocLinks.map((a) => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)))).filter(Boolean);
    let ticking = false;
    const paintScroll = () => {
      ticking = false;
      if (body && (fill || pct)) {
        const top = body.getBoundingClientRect().top + window.scrollY;
        const span = Math.max(body.offsetHeight - window.innerHeight * 0.6, 1);
        const p = Math.min(1, Math.max(0, (window.scrollY - top + window.innerHeight * 0.4) / span));
        if (fill) fill.style.width = (p * 100).toFixed(1) + '%';
        if (pct) pct.textContent = p > 0.01 ? Math.round(p * 100) + '%' : '';
      }
      if (heads.length) {
        let current = -1;
        heads.forEach((h, i) => { if (h.getBoundingClientRect().top <= window.innerHeight * 0.35) current = i; });
        tocLinks.forEach((a, i) => a.classList.toggle('is-active', i === current));
      }
    };
    const fitSide = () => {
      if (!side) return;
      const stuck = parseFloat(getComputedStyle(root).getPropertyValue('--scroll')) || 92;
      const free = window.innerHeight - side.offsetHeight - 24;
      side.style.top = Math.min(stuck, free) + 'px';
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(paintScroll); } };
    if (root) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { fitSide(); onScroll(); });
      window.addEventListener('load', fitSide);
      fitSide(); paintScroll();
    }

    /* delivery date: same business-day logic as sections/gc-product-full.liquid (no cutoff, skips Sat/Sun) */
    document.querySelectorAll('[data-gc-delivery-text]').forEach((el) => {
      const biz = parseInt(el.dataset.deliveryDays, 10);
      if (!biz || el.textContent.indexOf('{delivery_date}') === -1) { el.textContent = el.textContent.replace(/\s*\{delivery_date\}\.?/, '.'); return; }
      const d = new Date(); let added = 0;
      while (added < biz) { d.setDate(d.getDate() + 1); const dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
      const loc = { en: 'en-US', de: 'de-DE', fr: 'fr-FR', it: 'it-IT', es: 'es-ES', sv: 'sv-SE' }[el.dataset.deliveryLang] || 'en-US';
      el.textContent = el.textContent.replace('{delivery_date}', d.toLocaleDateString(loc, { weekday: 'long', month: 'short', day: 'numeric' }));
    });

    /* mobile sticky bar: show once the decision row (or the TOC) has scrolled past, hide at the end rail, dismiss for the session */
    const bar = document.querySelector('[data-gc-bar]');
    if (bar && 'IntersectionObserver' in window) {
      let dismissed = false;
      try { dismissed = sessionStorage.getItem('gcj_bar_off') === '1'; } catch (error) {}
      const trigger = document.querySelector('[data-gc-decide]') || document.querySelector('.gc-toc') || document.querySelector('.gcj__body');
      const stop = document.querySelector('[data-gc-rail]');
      let passed = false, atRail = false;
      const paint = () => bar.classList.toggle('is-on', passed && !atRail && !dismissed);
      if (trigger) new IntersectionObserver(([e]) => { passed = !e.isIntersecting && e.boundingClientRect.top < 0; paint(); }, { threshold: 0 }).observe(trigger);
      if (stop) new IntersectionObserver(([e]) => { atRail = e.isIntersecting; paint(); }, { threshold: 0 }).observe(stop);
      const close = bar.querySelector('[data-gc-bar-close]');
      if (close) close.addEventListener('click', () => { dismissed = true; paint(); try { sessionStorage.setItem('gcj_bar_off', '1'); } catch (error) {} });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    var players = document.querySelectorAll('.audio-player');
    if (!players.length) return;
    var speeds = [1, 1.25, 1.5, 2, 0.75];

    players.forEach(function (player) {
      var controls = player.querySelector('[data-audio-controls]');
      if (!controls) return;
      var audio = document.getElementById(controls.getAttribute('data-audio-target'));
      if (!audio) return;

      var playBtn = controls.querySelector('[data-action="toggle"]');
      var speedBtn = controls.querySelector('[data-action="speed"]');
      var speedLabel = controls.querySelector('[data-speed-label]');
      var wave = controls.querySelector('[data-progress]');
      var waveFg = controls.querySelector('[data-wave-fg]');
      var current = controls.querySelector('[data-current]');
      var duration = controls.querySelector('[data-duration]');
      var speedIdx = 0;

      function fmt(t) {
        if (!isFinite(t)) return '0:00';
        var m = Math.floor(t / 60);
        var s = Math.floor(t % 60);
        return m + ':' + (s < 10 ? '0' : '') + s;
      }

      function setProgress(pct) {
        player.style.setProperty('--ap-progress', pct + '%');
        if (waveFg) {
          var w = wave.offsetWidth;
          waveFg.style.width = (pct / 100 * w) + 'px';
          // Keep inner bars at full waveform width so they align with bg
          var inner = waveFg.querySelectorAll('span');
          // No-op: structure handles via overflow clip
        }
      }

      function updateProgress() {
        if (!audio.duration) return;
        var pct = (audio.currentTime / audio.duration) * 100;
        setProgress(pct);
        if (current) current.textContent = fmt(audio.currentTime);
      }

      audio.addEventListener('loadedmetadata', function () {
        if (duration) duration.textContent = fmt(audio.duration);
      });
      audio.addEventListener('timeupdate', updateProgress);
      audio.addEventListener('play', function () {
        player.setAttribute('data-playing', 'true');
        playBtn.setAttribute('aria-pressed', 'true');
        playBtn.setAttribute('aria-label', 'Pause audio');
      });
      audio.addEventListener('pause', function () {
        player.setAttribute('data-playing', 'false');
        playBtn.setAttribute('aria-pressed', 'false');
        playBtn.setAttribute('aria-label', 'Play audio');
      });
      audio.addEventListener('ended', function () {
        player.setAttribute('data-playing', 'false');
        playBtn.setAttribute('aria-pressed', 'false');
      });

      playBtn.addEventListener('click', function () {
        if (audio.paused) {
          document.querySelectorAll('.audio-player audio').forEach(function (other) {
            if (other !== audio) other.pause();
          });
          audio.play();
        } else {
          audio.pause();
        }
      });

      wave.addEventListener('click', function (e) {
        if (!audio.duration) return;
        var rect = wave.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var pct = Math.max(0, Math.min(1, x / rect.width));
        audio.currentTime = pct * audio.duration;
        setProgress(pct * 100);
      });

      // Ensure fg waveform inner bars stay aligned with bg as it clips
      if (waveFg) {
        function syncFgWidth() {
          waveFg.style.setProperty('--ap-wave-width', wave.offsetWidth + 'px');
        }
        syncFgWidth();
        window.addEventListener('resize', syncFgWidth);
      }

      if (speedBtn) speedBtn.addEventListener('click', function () {
        speedIdx = (speedIdx + 1) % speeds.length;
        audio.playbackRate = speeds[speedIdx];
        if (speedLabel) speedLabel.textContent = speeds[speedIdx] + '×';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
